import { createApp } from 'vue';
import FlyoverShare from './FlyoverShare.vue';
import { i18n } from '../../i18n';

// Mount only on pages that include the mount point (the recording show page).
const targetElement = document.querySelector('#flyover_share');
if (targetElement) {
  const app = createApp(FlyoverShare);
  app.use(i18n);
  const vm = app.mount(targetElement) as unknown as { showFlyover: (cfg: unknown) => void };
  // Global entry point the recordings entrypoint wires to the "Share flyover" button.
  (window as unknown as { showFlyoverShare?: (cfg: unknown) => void }).showFlyoverShare = (cfg) =>
    vm.showFlyover(cfg);
}
